import * as landRegistryActions from '../../../actions/landRegistry';
import i18nMixin from '../../i18nMixin';
import * as landRegistryProducts from '../../../dataServices/landRegistryProducts';
import { coreStore, Products } from '@ambita/ambita-components-core';
import { mount, TagInstance } from 'riot';
import * as landRegistryConstants from '../../../constants/landRegistry';
import landRegistryStore from '../../../stores/landRegistry';
import { ProductWithProductFee } from '../../../typings/LandRegistryLookup';

const { events: landRegistryEvents } = landRegistryConstants;
const MODAL_TAG_NAME = 'ambita-instant-purchase';
const ALLOWED_PANTEBOK_REPORT_CHANNELS = ['NYEINFOLAND', 'NYEINFOLAND_CARD_1F4B3'];

const appendTag = (parentNode: Node, tagName: string, opts?: any): TagInstance => {
  const tagElement = document.createElement(tagName);
  parentNode.appendChild(tagElement);
  const mountedTags = mount(tagElement, tagName, opts);
  return mountedTags[0];
};

const pantebokErrorHandler = (tag): void => {
  tag.productAvailable = false;
  tag.update();
};

const setPantebokProductPrice = (tag): void => {
  landRegistryProducts.getPantebokProduct().then((pantebokProduct: Products.Product) => {
    tag.pantebokProduct = pantebokProduct;
    tag.productAvailable = true;
    tag.update();
  }).catch(() => pantebokErrorHandler(tag));
};

const mountInstantPurchaseTag = (tagOptions: any): void => {
  appendTag(document.body, MODAL_TAG_NAME, tagOptions);
};

const addToCart = (tag): void => {
  landRegistryProducts.getPantebokProduct().then((pantebokProduct: Products.Product) => {
    landRegistryActions.addPantebokProduct(
      tag.opts.reference,
      pantebokProduct,
      tag.opts.orderData,
      tag.opts.rightKey
    );
  }).catch(() => pantebokErrorHandler(tag));
};

export const init = async (tag): Promise<void> => {
  tag.mixin(i18nMixin);
  tag.pantebokPurchased = false;
  const clientId = await coreStore.getClientId();

  const isAllowedChannel = ALLOWED_PANTEBOK_REPORT_CHANNELS.includes(clientId);

  tag.purchaseAllowed = isAllowedChannel;
  tag.opts.purchaseAllowed = isAllowedChannel;
  setPantebokProductPrice(tag);
  tag.purchasePantebok = (): void => {
    if ((<any>coreStore.getSettings()).openLookupDirectly) {
      addToCart(tag);
    } else {
      landRegistryProducts.getPantebokProduct().then((pantebokProduct: ProductWithProductFee) => {
        mountInstantPurchaseTag({
          reference: tag.opts.reference,
          product: pantebokProduct,
          injectedAmount: pantebokProduct.price.salesPriceVat + pantebokProduct.price.productFee,
          orderData: tag.opts.orderData,
          rightKey: tag.opts.rightKey
        });
      }).catch(() => pantebokErrorHandler(tag));
    }
  };

  const setPantebokPurchasing = (rightKey): void => {
    if (tag.opts.rightKey === rightKey) {
      tag.pantebokIsPurchasing = true;
      tag.update();
    }
  };

  const setPantebokPurchased = (rightKey): void => {
    if (tag.opts.rightKey === rightKey) {
      tag.pantebokIsPurchasing = false;
      tag.pantebokPurchased = true;
      tag.update();
    }
  };

  const setPantebokPurchaseFailed = (rightKey): void => {
    if (tag.opts.rightKey === rightKey) {
      tag.pantebokIsPurchasing = false;
      tag.pantebokPurchased = false;
      tag.pantebokPurchaseFailed = true;
      tag.update();
    }
  };

  tag.on('mount', () => {
    landRegistryStore.on(landRegistryEvents.PURCHASE_PANTEBOK, setPantebokPurchasing);
    landRegistryStore.on(landRegistryEvents.PURCHASED_PANTEBOK, setPantebokPurchased);
    landRegistryStore.on(landRegistryEvents.PURCHASE_PANTEBOK_FAILED, setPantebokPurchaseFailed);
  });

  tag.on('unmount', () => {
    landRegistryStore.off(landRegistryEvents.PURCHASE_PANTEBOK, setPantebokPurchasing);
    landRegistryStore.off(landRegistryEvents.PURCHASED_PANTEBOK, setPantebokPurchased);
    landRegistryStore.off(landRegistryEvents.PURCHASE_PANTEBOK_FAILED, setPantebokPurchaseFailed);
  });

  tag.on('update', (newOpts) => {
    tag.purchaseAllowed = tag.opts.purchaseAllowed;

    if (newOpts && newOpts.reference) {
      tag.opts.reference = newOpts.reference;
    }
  });
};
